module.exports = __webpack_public_path__ + "img/icon_pay_01.25914072.svg";